// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P2crv","title":"styles_title__1Xpks"};